// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"621":"5fb568a1","743":"6cd9723e","917":"aa795c19"}[chunkId] + ".chunk.js";
};